import { Injectable } from "@angular/core";
import { IMapDrawLayer, IMapDrawOption, IMapGeometry } from "../../../map.settings";

export interface IDrawItem {
    label: string;
    geometry: any;
    layer: IMapDrawLayer;
}
export interface IDrawGroup {
    id: any;
    title: string;
    optionTargetLayer: any;
    drawOptions: IMapDrawOption[];
    items: IDrawItem[];
    order: number;
    hideCounter: boolean;
    hideInDrawMenu: boolean;
}

@Injectable({
    providedIn: "root"
})

export class MapDrawService {

    updateDrawGroups(target: IDrawGroup[], updated: IDrawGroup[]) {
        if (!updated) {
            return;
        }
        const removed = target.filter(t => updated.find(u => u.id === t.id) === undefined);
        const added = updated.filter(u => target.find(t => u.id === t.id) === undefined);
        removed.forEach(r => {
            target.splice(target.indexOf(r), 1);
        });
        target.forEach(t => {
            const grp = updated.find(u => u.id === t.id);
            t.items = grp.items;
            t.drawOptions = grp.drawOptions;
            t.title = grp.title;
            t.hideInDrawMenu = grp.hideInDrawMenu;
        });
        target.push(...added);
        target = this.sortDrawGroups(target);
    }

    getDefaultDrawGroupsFromLayers(drawLayers: IMapDrawLayer[]) {
        return this.sortDrawGroups(this.getVisibleLayers(drawLayers)?.map(l => {
            const group = this.getDrawGroupFromDrawLayer(l);
            group.items = l.showGeometriesMenu === false ? [] : this.getVisibleGeometries(l).map(g => this.getDrawItemFromMapGeometry(g, l));
            return group;
        }));
    }

    getDrawGroupFromDrawLayer(drawLayer: IMapDrawLayer) {
        return {
            id: drawLayer.id,
            title: drawLayer.title,
            drawOptions: drawLayer.drawOptions,
            optionTargetLayer: drawLayer,
            order: drawLayer.menuOrder,
            hideCounter: drawLayer.hideMenuCounter,
            items: [],
            hideInDrawMenu: drawLayer.hideInDrawMenu
        } as IDrawGroup;
    }

    getDrawItemFromMapGeometry(mapGeometry: IMapGeometry, layer: IMapDrawLayer) {
        return {
            label: mapGeometry.label,
            geometry: mapGeometry,
            layer: layer
        };
    }

    private sortDrawGroups(drawGroups: IDrawGroup[]): IDrawGroup[] {
        // eslint-disable-next-line sonarjs/no-misleading-array-reverse
        return drawGroups?.sort((a, b) => (a.order ?? 1000) - (b.order ?? 1000));
    }

    private getVisibleLayers(layers: IMapDrawLayer[]) {
        return layers?.filter(l => l.visible && l.showGeometriesMenu && this.getVisibleGeometries(l).length > 0 || l.drawOptions?.length > 0);
    }

    private getVisibleGeometries(layer: IMapDrawLayer): IMapGeometry[] {
        if (layer.allowInvisibleGeometries) {
            return layer.geometries ?? [];
        }
        return layer.geometries?.filter(g => g.visible !== false) ?? [];
    }
}
